import { Link } from "react-router-dom";
import { CustomComponentProps } from "utils/types/generalTypes";

export type trendingItemObject = {
    hashtag: string;
    nPosts: number | string;
    trending?: boolean;
};

export type TopNewsItemProps = CustomComponentProps & {
    item: trendingItemObject;
};

const TopNewsItem = ({ item }: TopNewsItemProps) => {
    return (
        <Link to={`/hashtag/${item.hashtag}`} className="story-block">
            <div className="story-meta">
                <span>
                    #{item.hashtag}{" "}
                    {item.trending ? (
                        <span className="second-span-story-meta">
                            - Trending
                        </span>
                    ) : (
                        ""
                    )}
                </span>
                <span className="second-span-story-meta">
                    {item.nPosts} posts
                </span>
            </div>
        </Link>
    );
};

export default TopNewsItem;
